<template>
    <div id="footnotes">
        <ul>
            <li v-for="(footnote, index) in data" :key="'footnote-' + index" :id="'footnote-' + footnote.id" class="footNoteRow">
                <span class="footNoteNumber">{{footnote.id}}</span>
                <span class="footNoteText" v-html="footnote.description"></span>
            </li>
        </ul>

    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as axios from 'axios';

export default {
    name: 'Footnotes',
    components: {
    },
    props: {
        reportAPIURLConfig: {
            required: true
        }
    },
    computed: {
        ...mapGetters([
            // 'pieChartsData',
            // 'barChartData',
            // 'tableData'
        ]),
    },
    data: function () {
        return {
            data: null,

        };
    },
    async mounted () {
        if (!this.$parent.footNoteData) {
            const response = await axios.get(encodeURI(this.reportAPIURLConfig + "/CategoricalSpendings/footnotes"));

            if (response && response.status === 200) {
                var data = response.data;

                this.data = data;
                this.$parent.footNoteData = copyData(data);
            }
        } else {
            this.data = copyData(this.$parent.footNoteData);
        }
    },
    methods: {
        // back () {
        //     this.drilldownActive = false;
        // },

    }
};
</script>

<style lang="scss" scoped>
    #footnotes {
        margin-top: 50px;
        padding: 20px;
        background-color: #f2f2f2;
        border-radius: 5px;
        font-size: 16px;
    }

    ul {
        display: table;
        margin: 0;
        padding: 0;
        list-style: none;
    }

    li {
        padding: 0;
        // margin: 10px 0;
        line-height: 1.25em;
    }

    .footNoteRow,
    .footNoteNumber {
        padding: 8px 0;
    }

    .footNoteRow {
        display: table-row;
    }

    .footNoteNumber {
        display: table-cell;
        padding-right: 5px;
        font-weight: 700;
        text-align: right;
    }

    .footNoteText {
        display: table-cell;
        a {
            text-decoration: none;
        }
    }
</style>

